import React from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import API from "../../../Services/BaseService";
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import { useSelector } from 'react-redux';
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import Loading from "../../../Component/Loading/Loading";
import PageNotFound from '../../FallBackUI/PageNotFound';
import ls from 'local-storage';



const MyProfile = (props) => {
  const history = useHistory();
  const [accountDetails, setaccountDetails] = useState([]);
  const sellerDetails = useSelector(state => state.LoginReducer.payload);
  const [loading, setLoading] = useState(true);
  const [phoneNo, setPhoneNo] = useState("");
  const [mobileNo, setMobileNo] = useState("");

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const backUrl = ls.get("backredirection");
  console.log("check the back url", backUrl);
  const back = backUrl[(backUrl.length) - 1];
  console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

  console.log("my profile sellerDetails===", sellerDetails)

  const billofsale = ls.get("BillofSaleId")
  console.log("check the bill of sale value", billofsale);
  const CarId = ls.get("BillOfSaleCarId")

  async function fetchAccountDetails() {
    let request = {
      seller_id: sellerDetails.seller_id,
      seller_token: sellerDetails.seller_token,
    };
    const state = API.post('seller_profile/condition', request);
    state.then(res => {
      console.log("seller_profile", res)
      if (res.data.success === true) {
        setaccountDetails(res.data.data);

        formatPhoneNO(res.data.data[0]?.phonenolist.map(data => data.phone_no))

        // if (res.data.data[0]?.mobile_no != "" && res.data?.data[0]?.mobile_no != null){
        //   formatMobileNO(res.data.data[0]?.mobile_no)
        // }
        // if (res.data.data[0]?.phone_no != "" && res.data?.data[0]?.phone_no != null){
        //   formatPhoneNO(res.data.data[0]?.phone_no)
        // }
        setLoading(false);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  // function onHandleEdit(e){
  //   history.push("/editmyprofile/"+e);
  // }

  function onHandleEdit(item) {
    history.push({
      pathname: "/editmyprofile",
      state: { id: item.seller_dealer_id, BillofSale: billofsale, CarId: CarId }
    });
    ls.set("backredirection", [...backUrl, "/myprofile"])
    ls.set("BillofSaleId", billofsale)
  }
  useEffect(() => {
    fetchAccountDetails();
  }, []);
  function formatMobileNO(value) {
    var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    console.log("value of x", x);
    value = '(' + x[1] + ') ' + x[2] + '-' + x[3];
    console.log("mobileno", value);
    return value;
  }
  function formatPhoneNO(value) {
    let i = 0;
    for (i = 0; i < value.length; i++) {
      var x = 0;
      x = value[i].replace(/\D/g, "").match(/(\d{3})(\d{3})(\d{4})/);

      value[i] = "(" + x[1] + ")" + x[2] + "-" + x[3];

    }
    return setPhoneNo(value);
  }

  const handleBackButton = () => {

    history.push({
      pathname: back,
      state: { BillofSale: billofsale, CarId: CarId },
    });
    ls.set("backredirection", backUrl.slice(0, -1))

  }

  const handleFlag = () => {
    ls.set("BillofSaleId", "")
    ls.get("BillOfSaleCarId", "")
  }

  return (
    <div>
      <main id="main" className="inner-page">
        <div id="myprofiles" className="myprofiles">
          {errorFlag === true ? <PageNotFound error={errors} /> :
            <>
              {loading ? <Loading /> :
                <div className="container-fluid inner-page-space">
                  <div class="common-heading">
                    <div className="row">
                      <div className="col-lg-2">
                        <div class="back-btn">
                          <a class="back-btn-primary" onClick={() => handleBackButton()}>
                            <i class="bx bx-chevron-left"></i> Back
                          </a>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div class="title">
                          <p class="inner-title">My Profile</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="myprofilesblock col-lg-12">
                    <div className="row content">
                      <div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">
                        <ManageAccountLinks handleFlag={handleFlag} />
                      </div>
                      <div className="col-lg-8 col-md-12 col-sm-12 myprofilerightblock">
                        <div className="myprofilerighttableblock">
                          {accountDetails?.length > 0 ? accountDetails.map((item) =>


                            <div className="myprofilerighttable">
                              <h3>My Details<span><button className="ant-btn" onClick={() => onHandleEdit(item)}><i className="icofont-ui-edit"></i> Edit</button></span></h3>
                              {/* <p>Location where transport carriers will drop of a vehicle that you have purchased</p> */}
                              <div className='myprofiltable'>
                                <div class="table-responsive">
                                  <table>

                                    <tr>
                                      <td><span className="tdcol1">First Name</span><span>{item.first_name}</span></td>
                                      <td><span className="tdcol1">Address</span><span>{item.address}</span></td>
                                    </tr>
                                    <tr>
                                      <td><span className="tdcol1">Last Name</span><span>{item.last_name}</span></td>
                                      <td><span className="tdcol1">City</span><span>{item.city_name}</span></td>
                                    </tr>
                                    <tr>
                                      <td><span className="tdcol1">Phone #</span><span>{item.country_code}{formatMobileNO(item.phone_no)} </span></td>
                                      <td><span className="tdcol1">Extension</span><span>{item.extentation}</span></td>

                                      {/* <td><span className="tdcol1">Phone #</span>{phoneNo.map((data)=> <span>{data}</span>)}</td> */}
                                    </tr>
                                    <tr>
                                      <td><span className="tdcol1">State</span><span>{item.state_name}</span></td>
                                      <td><span className="tdcol1">Email </span><span>{item.email}</span></td>
                                    </tr>

                                    <tr>
                                      <td><span className="tdcol1">Zip code</span><span>{item.zipcode}</span></td>
                                      <td></td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ) : ""}
                        </div>
                        <div className="mgaccountrighttableblock mt-3 pt-4">
                          {/* <h3>Manage Account Password<span><a class="ant-btn" href="/changepassword"><i class="icofont-ui-edit"></i> Edit</a></span></h3> */}
                          <h3>Manage Account Password<span><button className="ant-btn" onClick={() => history.push("/changepassword")}><i className="icofont-ui-edit"></i> Edit</button></span></h3>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>}</>}
        </div>


      </main>
      <section id="playstoreBlock" className="playstoreBlock">
        <div className="container">


          <div className="row content">
            <div className="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />
            </div>

          </div>

        </div>
      </section>

    </div>


  );
};

export default MyProfile;